import type { Ladder, LadderProgress, LadderStatus } from "../types";

export const getLadderProgress = (
  ladder: Ladder | null | undefined,
  ladderProgress: LadderProgress[] | null | undefined,
): LadderProgress => {
  return (
    (ladderProgress || []).find(
      (progress) => String(progress?.ladderId) === String(ladder?.id),
    ) ||
    ({
      overallStatus: "NOT_STARTED",
    } as LadderProgress)
  );
};

export const getLadderStatus = (
  ladder: Ladder | null | undefined,
  ladderProgress: LadderProgress[] | null | undefined,
): LadderStatus => {
  return (
    getLadderProgress(ladder, ladderProgress)?.overallStatus || "NOT_STARTED"
  );
};

export const getLadderStatusLabel = (status: string): string => {
  switch (status) {
    case "COMPLETED":
      return "Completed";
    case "IN_PROGRESS":
      return "In Progress";
    default:
      return "Not Started";
  }
};
